import {EntityModel} from "@fedeltapointofsale/data-client";
import {SizeGroupRelationData} from "./size-group-relation.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SizeGroupRelationEntityModel extends EntityModel<SizeGroupRelationData> {

    constructor(injector: Injector) {
        super(injector, SizeGroupRelationData);
    }

    protected override onAfterLoadEntity(entityData: SizeGroupRelationData): void {
        const standardProduct: number = this.data.standardSellable.sellableId
        const sellableArr: Array<any> = this.data.sellableSizeRelations
        for (let i = 0; i < sellableArr.length; i++) {
            if (standardProduct == sellableArr[i].sellable.sellableId) {
                sellableArr[i].standardProduct = true;
            }
        }
    }
}
